import {XauditModel} from '../../../models/xaudit.model';

export class OperatoryModel extends XauditModel {
    OperatoryId: string;
    LOCID: number;
    OperatoryOrder: number;
    OperatoryName: string ;
    OperatoryDescription: string ;
    color: string ;
    avatar: string ;
    LocationShortName: string;
    LocAndOpName: string;
}

export class LocationModel extends XauditModel {

    LOCID: number;
    Name: string;
    LocationShortName: string;
    CanceledApptOpearatoryId: string;
}


